import React, {useEffect} from "react";
import Container from "react-bootstrap/Container";

const PolicyContent = () => {


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <section className="policy-content">
      <Container>
        <div className="row">
          <div className="col-lg-12 ">
            <h2 className="main-title">Policies</h2>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="main-policy-content-wrap">
              <div className="policy-title">Fare and Fuel Policy</div>

              <div className="sub-details">
                <p>
                  Enjoy the free fuel for the period the vehicle is handed over
                  to you by the company, starting from your drive to once your
                  vehicle is left nil with fuel. As per the fare policy, the
                  vehicle will become independent of your fare coverage provided
                  by SKYCARS and the later used fuel expenditure for your drive
                  to be incurred by your self-customer liabilities.
                </p>

                <p>
                  When you’re done with the usage of our rental car services in
                  Mumbai and ready to get back to our spot, while handing over
                  the vehicle back to us, it will have to be present with the
                  similar amount of fuel the vehicle was provided to you at the
                  time of the delivery.
                </p>

                <p>
                  The fuel reimbursement will be offered to you as well by the
                  company under customer rights to transparency at the end of
                  your happy rides. If you leave the vehicle to us with the bar
                  of fuel amount more than what was captured and noticed by our
                  executive officials at the time when you’re given the keys to
                  the rental car by the company and while submitting to the
                  successful delivery of the vehicle service to you, the fuel
                  reimbursement would be noticed and you’ll be guarded by the
                  policy.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="refund-policy-wrap">
              <div className="policy-title">Cancellation Policy</div>
              <div className="sub-details">
                <p>
                  We do abide by an easy-to-get refund policy while cancellation
                  of your booking. However, we charge a nominal fee for your
                  cancellation under certain circumstances and events.
                </p>
                <p>
                  {" "}
                  We are keener not to charge for your cancellation of the
                  booking for a genuine cause or reason, however, if you’re late
                  in filling up with the cancellation procedure exceeding six
                  hours from the time of your booking slot, then we would like
                  to charge you some percentage of the amount you’ve already
                  paid as per the company rule to the cancellation fee policy
                  structure.
                </p>
                <p>
                  You can now be with ease with those mood swingers and mind
                  shifters towards your riding plans as well. Again, we don't
                  want you to be victimized by that pre-consumed notion to
                  cancel the booking or change the idea to have rental cars in
                  Mumbai.
                </p>
                <p>
                  We’re introducing you to the unlimited free rescheduling
                  policy for the next six months of your first-ever rental car
                  service booking in Mumbai with SKYCARS. You can change the
                  time slots you recently booked as per your convenience quickly
                  using our App or browsing through our website, and shift them
                  following your new plan sets.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-mg-12">
            <div className="policy-title">Agreement Policy</div>

            <div className="sub-details">
              <p>
                We hereby are agreeing to the privacy policy of our customers
                and the role payable to protect our customer’s rights. We
                declare our nuances of liabilities against what we’re offering
                to our customers in the domain of car rental services in Mumbai.
              </p>
              <p>
                The data shared and provided by the customers are under the
                electronic records of the site and required by the law provided
                with each provision, sanction, and regulation under the
                information technology act, 2000, in Indian legislation
                conforming to the legal recognition for our digital signatures
                and transactions which are being reached out on-site through the
                technical web channel of interchanged electronic data.
              </p>
              <p>
                We employ enough security exchanges for our customers against
                their shared personal data and unless permitted by law, the data
                is stored under highly secured confidentiality.
              </p>
              <p>
                Our company receives the information you’ve provided along with
                the IP address in form of and under the sign-in demands over the
                website and ensures its quantifiable data tools to provide
                appropriate measures that are assigned to our data management
                team and prevented any unlawful activities and source of cyber
                fraud catch.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default PolicyContent;
